module.exports = __webpack_public_path__ + "img/2. NANO HAIR 5 PACKS.jpg";